import React from "react";
import FieldWrapper from "../Common/FieldWrapper";
import purifyHTML from "../../../utils/purifyHTML";

export default class Checkbox extends FieldWrapper {
  handleChange = (e) => {
    this.props.formikForm.setFieldValue(
      this.props.config.name,
      e.target.checked
    );
    this.props.formikField.onBlur(e); //validate directly for errors
  };

  renderField() {
    const {
      form,
      formikField,
      isRequired,
      config: { name, label, readOnly, disabled, show },
    } = this.props;
    const id = name + (form.props.config.guid || "");

    const listeners = {};
    if (readOnly) {
      listeners.onClick = (e) => {
        e.preventDefault();
      };
    }
    return (
      <div
        className={`field__group ${
          show !== null && show === "False" ? "field_hidden" : ""
        }`}
      >
        <div className="field__option field__option--checkbox">
          <input
            className="field__checkbox"
            type="checkbox"
            id={id}
            checked={formikField.value}
            aria-required={!!isRequired}
            disabled={!!disabled}
            {...formikField}
            onChange={this.handleChange}
            {...listeners}
          />
          <label
            htmlFor={id}
            className="field__option-label"
            dangerouslySetInnerHTML={purifyHTML(label)}
            {...listeners}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Field/Checkbox.js